<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="catalogos.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="catalogos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum catálogo encontrado"
      loading-text="Carregando catálogos..."
      :options="optionsList"
    >
      <template v-slot:item.grupoCompra.nome="{ item }">
        {{ gruposNomes(item) }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon
               @click="goToEditCatalogo(item, false)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
<!--        <v-tooltip bottom>-->
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn icon-->
<!--                   @click="onClickCopy(item)" v-on="on">-->
<!--              <v-icon>mdi-content-copy</v-icon>-->
<!--            </v-btn>-->
<!--          </template>-->
<!--          <span>Copiar catálogo</span>-->
<!--        </v-tooltip>-->
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
export default {
  props: {
    catalogos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Nome',
          value: 'nome',
        },
        {
          text: 'Grupo',
          value: 'grupoCompra.nome',
        },
        {
          text: 'Ativo',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    gruposNomes() {
      return (item) => {
        if (item.gruposCompras.length > 1) {
          return `${item.gruposCompras[0].nome} (+ ${item.gruposCompras.length - 1})`;
        }
        return item.gruposCompras[0].nome;
      };
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToEditCatalogo(item, isCopy) {
      this.$router.push({
        name: 'main.catalogo.edicao',
        params: {
          id: item.id,
          isCopy,
        },
      });
    },
    onClickCopy(item) {
      this.goToEditProduto(item, true);
    },
  },
};
</script>
